module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>Files</h1>\n<p>\n  The <b>Files</b> collection stores links to useful files. For example, a link to a PDF for one of the devices. Additionally, any reports that get generated are stored here as well.\n</p>\n'+
((__t=(APP.Tools.icon( "files", "Icon for Files", "watermark")))==null?'':__t)+
'\n';
}
return __p;
};
